var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargerCircontrol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "183 150 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8C8C8",
    d: "M253.971,155.616"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B9B9B7",
    d: "M233.883,156.744"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B9B9B7",
    d: "M253.971,155.616"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B9B9B7",
    d: "M215.399,130.64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D6D6D4",
    d: "M276.563,162.188c0.641,3.542,0.479,6.771,0.729,10.438 c0.114,17.018-0.003,53.686-0.323,55.001c-5.046,0.999-10.092,1.996-15.139,2.994c-0.58-18.62,3.52-38.591,1.486-57.913 c-0.376-3.581-4.686-5.148-8.798-5.127c-13.155,0.068-26.311-0.048-39.466-0.068c-4.728-0.007-8.665,2.129-9.07,6.82 c-1.556,18.006-2.254,36.058,0.251,54.068c-4.59,2.865-9.172-0.826-13.759-0.016c-0.004-22.254-2.313-44.563,1.618-66.721 c0.349-0.039,0.699-0.077,1.048-0.115c2.911-0.007,5.823-0.015,8.734-0.023c4.754,0.003,9.508,0.006,14.262,0.009 c0.374-0.292,0.749-0.584,1.123-0.877C238.061,161.105,257.76,161.74,276.563,162.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B9B9B7",
    d: "M273.059,231.555c-1.63,0.07-3.26,0.14-4.892,0.209 c-3.716,0.316-7.43,0.633-11.145,0.95c1.603-0.698,3.205-1.396,4.807-2.094c5.046-0.998,10.093-1.995,15.139-2.994 C277.43,230.691,277.438,239.063,273.059,231.555z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#747473",
    d: "M194.091,161.664c-3.931,22.158-1.622,44.467-1.618,66.721 c-0.425,5.111,4.021,2.512,6.027,3.774c2.068,1.302,5.54-1.146,6.799,2.48c-2.341,0.386-4.683,0.769-7.023,1.161 c-0.942,0.157-1.88,0.335-2.82,0.504c0.447,0.371,0.907,1.077,1.339,1.061c4.07-0.154,8.136-0.432,12.203-0.674 c16.336,0.016,32.673,0.031,49.01,0.047c4.58,0.114,9.16,0.229,13.739,0.342c-1.955-0.648-3.911-1.296-5.866-1.943 c0.763-1.125,1.526-2.248,2.289-3.373c1.63-0.069,3.26-0.139,4.891-0.209c1.365,1.6,4.316,1.195,3.816,4.445 c-0.528,3.431,0.958,4.396-6.92,4.744c-22.644,1-44.83,0.381-67.58,0.318c-0.986,0.015-3.327-0.39-4.313-0.375 c-2.198,0.221-7.643-0.617-7.75-1.813c-0.938-10.438-0.922-50.778-0.729-65.862C189.688,164.807,188.542,162.042,194.091,161.664 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B9B9B7",
    d: "M224.244,156.861"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#747473",
    d: "M219.258,160.658c-0.374,0.292-0.749,0.584-1.123,0.877 C218.509,161.242,218.884,160.95,219.258,160.658z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8C8C8",
    d: "M247.565,251.646"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#747473",
    d: "M277.588,172.626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#A9A9A9",
    d: "M219.964,232.834c12.353-0.039,24.706-0.08,37.059-0.12 c3.715-0.317,7.429-0.634,11.145-0.95c-0.762,1.125-1.525,2.248-2.288,3.373c1.956,0.647,3.911,1.295,5.866,1.943 c-4.58-0.113-9.16-0.228-13.74-0.342c-16.334-1.773-32.671-1.717-49.009-0.047c-4.067,0.242-8.132,0.52-12.203,0.674 c-0.433,0.017-0.893-0.689-1.339-1.061c0.94-0.169,1.878-0.347,2.82-0.504c2.34-0.393,4.682-0.775,7.023-1.161 c-1.259-3.627-4.731-1.179-6.799-2.48c-2.005-1.263-6.452,1.337-6.027-3.774c4.588-0.811,9.17,2.881,13.76,0.016 c1.608,1.254,3.216,2.508,4.824,3.761c0.971,0.202,1.941,0.405,2.912,0.607c1.691,0.019,3.381,0.036,5.072,0.056 C219.348,232.827,219.656,232.83,219.964,232.834z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#11151C",
    d: "M261.83,230.62c-0.658,1.302-3.019,1.917-4.807,2.094 s-24.706,0.081-37.059,0.12c-0.339-0.037-0.511-0.037-0.924-0.01c-1.69-0.02-3.381-0.037-5.072-0.056 c-0.97-0.202-1.636-0.165-2.912-0.607s-3.044-1.47-4.824-3.761s-1.808-36.062-0.251-54.068c0.405-4.69,4.342-6.827,9.07-6.82 c13.155,0.02,26.311,0.136,39.466,0.068c4.113-0.021,8.422,1.546,8.798,5.127C265.349,192.029,262.487,229.318,261.83,230.62z  M232.844,180.594c6.474,0,8.152-0.115,10.094-0.188c3.951-0.148,7.173,2.403,7.193-3.855c0.019-5.923-4.256-3.899-7.086-3.997 c-6.473-0.224-12.968,0.155-19.437-0.128c-3.438-0.15-4.156,1.122-4.154,4.245c0.002,3.523,1.708,4.241,4.677,4.033 C228.414,180.404,233.025,180.584,232.844,180.594z M238.063,197.129c1.884-0.426,3.881,0.594,3.415-1.8 c-0.246-1.262-0.621-3.142-2.764-2.326c-1.281,0.488-2.46,1.244-3.686,1.879C236.182,195.736,237.336,196.59,238.063,197.129z  M234.31,221.799c-3.699,0.444-7.308,0.877-10.916,1.311c5.775,0.342,11.547,0.775,17.327,0.97 c1.694,0.058,3.411-0.567,5.117-0.878C241.995,222.733,238.153,222.266,234.31,221.799z M238.557,186.286 c-1.331-1.007-2.656-2.475-3.091-2.247c-1.031,0.542-2.053,1.792-2.317,2.932c-0.341,1.476,0.382,3.252,2.294,2.702 C236.529,189.359,237.25,187.776,238.557,186.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B9B9B7",
    d: "M208.997,236.691c16.338-1.67,32.675-1.727,49.009,0.047 C241.67,236.723,225.333,236.707,208.997,236.691z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D6D6D4",
    d: "M232.523,180.234c0.182-0.01-4.109,0.17-8.392,0.471 c-2.969,0.208-4.675-0.51-4.677-4.033c-0.002-3.124,0.716-4.395,4.154-4.245c6.468,0.283,12.964-0.096,19.437,0.128 c2.83,0.098,7.105-1.926,7.086,3.997c-0.02,6.258-4.575,3-7.165,3.597C241.073,180.585,238.997,180.234,232.523,180.234z  M225.119,177.134c2.663,0.155,5.275,0.5,7.871,0.41c3.343-0.116,6.673-0.58,10.009-0.894c-3.285-0.473-6.665-1.638-9.826-1.205 C230.567,175.802,226.867,170.242,225.119,177.134z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#747473",
    d: "M238.063,197.129c-0.727-0.539-1.88-1.393-3.035-2.247 c1.225-0.635,2.404-1.391,3.686-1.879c2.143-0.815,2.518,1.064,2.764,2.326C241.943,197.723,239.946,196.703,238.063,197.129z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B9B9B7",
    d: "M234.31,221.799c3.844,0.467,7.686,0.935,11.528,1.402 c-1.707,0.311-3.423,0.936-5.117,0.878c-5.78-0.194-11.552-0.628-17.327-0.97C227.002,222.676,230.611,222.243,234.31,221.799z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#747473",
    d: "M238.557,186.286c-1.307,1.491-2.028,3.073-3.114,3.386 c-1.912,0.55-2.635-1.226-2.294-2.702c0.264-1.14,1.286-2.39,2.317-2.932C235.901,183.811,237.226,185.278,238.557,186.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B9B9B7",
    d: "M213.968,232.769c-0.97-0.202-1.941-0.405-2.912-0.607 C212.027,232.363,212.998,232.566,213.968,232.769z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#B9B9B7",
    d: "M225.119,177.134c1.748-6.892,5.448-1.332,8.055-1.689 c3.161-0.433,6.541,0.732,9.826,1.205c-3.336,0.314-6.667,0.778-10.009,0.894C230.394,177.634,227.782,177.289,225.119,177.134z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M276.5,239.875 c-0.521,0.625-81.295,3.367-86-0.75c-1.333-1.166-1.333-74.458,0-76.625s84.333-1.333,86,0S277.333,238.875,276.5,239.875z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M250.5,177.5 c0,1.657-1.343,3-3,3h-25c-1.657,0-3-1.343-3-3v-2c0-1.657,1.343-3,3-3h25c1.657,0,3,1.343,3,3V177.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerCircontrol);
export default __webpack_public_path__ + "static/media/charger_circontrol.0cd7fe59909409f6e1c8172406fc6e79.svg";
export { ForwardRef as ReactComponent };